import { oqulyqtarApi } from './api';

const versionApi = oqulyqtarApi.injectEndpoints({
    endpoints: (build) => ({
        getBackendVersion: build.query({
            query: () => ({
                url: '/public/version',
                method: 'GET',
            }),
            keepUnusedDataFor: 300,
        }),
    }),
});

export const { useGetBackendVersionQuery } = versionApi;
